import { store, clearCurrentUser, setIsLoggedIn, persistor } from 'store';

export function resetAccount() {
  store.dispatch(clearCurrentUser());
  store.dispatch(setIsLoggedIn(false));
  persistor.flush();
  store.dispatch({
    type: 'USER_LOGOUT',
  });
  persistor.persist();
}
